import * as React from "react";
import AuditLabelContext, { AuditLabelController } from './AuditLabelContext';

export function auditLabel(resources: AuditLabelController, controller: string, action: string, fieldName: string): string {
    if (!resources) return `[${fieldName}]`;
    if (resources && controller in resources && typeof resources[controller] === 'object'
    && action in resources[controller] && typeof resources[controller][action] === 'object') {
        const result = resources[controller][action][fieldName];
        if (result) return result;
    }
    console.warn('label da auditoria não encontrado:', { controller, action, fieldName });
    return `[${fieldName}]`;
}

export type AuditLabelFunction = (controller: string, action: string, fieldName: string) => string;

export interface WithAuditLabelProps {
    al: AuditLabelFunction
}

type WrappedComponentProps<P> = Omit<P, keyof WithAuditLabelProps>;

export function withAuditLabel<P extends WithAuditLabelProps>() {
    return (Component: React.ComponentType<P>): React.ComponentType<WrappedComponentProps<P>> => (props) => (
        <AuditLabelContext.Consumer>
            {({ resources }) => (
                <Component
                    {...props as P}
                    al={( controller: string, action: string, fieldName: string) => {
                        return auditLabel(resources, controller, action, fieldName);
                    }}
                />
            )}
        </AuditLabelContext.Consumer>
    );
}